import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChUpdateGeneralAttestationMutation as useChUpdateGeneralAttestationMutationType } from "@/modules/patients/detail/general-attestation/ch/services/__generated__/useChUpdateGeneralAttestationMutation.graphql"

const mutation = graphql`
  mutation useChUpdateGeneralAttestationMutation($input: Ch_updateGeneralAttestationInput!) {
    ch_updateGeneralAttestation(input: $input) {
      ch_GeneralAttestation {
        id
        ...chGeneralAttestationsFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChUpdateGeneralAttestationMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChUpdateGeneralAttestationMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChUpdateGeneralAttestationMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChUpdateGeneralAttestationMutation }
